import $ from "jquery";
import swiperSlider from "../swiperSlider/swiperSlider";

const seasonalBanner = {
    variables: {
        seasonalBanner: ".seasonal__banner",
        dataAsset: $(".seasonal__banner__container").attr("data-asset"),
        bannerContainer: $(".seasonal__banner__container"),
        bannerList: $(".seasonal__banner--list"),
        seasonalBannerSlider: ".seasonal__banner--slider",
        url: window.location.href,
    },

    methods: {
        init: function () {
            let swiperConfig = {
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                speed: 1000,
                slidesPerView: 1,
                spaceBetween: 0,
            };
            if ($(seasonalBanner.variables.seasonalBannerSlider).length > 1) {
                swiperSlider.methods.initializerSwiper(
                    seasonalBanner.variables.seasonalBannerSlider,
                    swiperConfig
                );
                $(seasonalBanner.variables.seasonalBannerSlider).each(function () {
                    seasonalBanner.methods.setupAutoplayControl(this);
                });
            }
        },

        // WCAG 2.2.2 Pause, Stop, Hide: a rotating banner needs a way to stop it.
        // Adds a Pause/Play button next to the dots, pauses while the banner is
        // hovered or has keyboard focus, and doesn't autoplay at all for users
        // who ask for reduced motion.
        setupAutoplayControl: function (sliderEl) {
            const swiper = sliderEl.swiper;
            const slideCount = $(sliderEl).find(".swiper-slide").not(".swiper-slide-duplicate").length;
            if (!swiper || !swiper.autoplay || slideCount < 2) {
                return;
            }
            const $container = $(sliderEl).closest(".swiper-container");
            const $bar = $container.find(".seasonal-pagination").first();
            if (!$bar.length || $bar.find(".seasonal-pagination__toggle").length) {
                return;
            }
            const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            let userPaused = reduceMotion;

            const $btn = $(
                '<button type="button" class="seasonal-pagination__toggle">' +
                    '<svg class="seasonal-pagination__icon seasonal-pagination__icon--pause" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h3v14H7zM14 5h3v14h-3z"/></svg>' +
                    '<svg class="seasonal-pagination__icon seasonal-pagination__icon--play" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>' +
                "</button>"
            );

            function render() {
                $btn.toggleClass("is-paused", userPaused)
                    .attr("aria-label", userPaused ? "Play slideshow" : "Pause slideshow");
            }
            function stop() {
                swiper.autoplay.stop();
            }
            function resume() {
                if (!userPaused) {
                    swiper.autoplay.start();
                }
            }

            $btn.on("click", function () {
                userPaused = !userPaused;
                if (userPaused) {
                    stop();
                } else {
                    resume();
                }
                render();
            });

            // Pause while the user is reading or interacting; resume afterwards
            // unless they pressed Pause.
            $container.on("mouseenter focusin", stop);
            $container.on("mouseleave", function () {
                if (!$container[0].contains(document.activeElement)) {
                    resume();
                }
            });
            $container.on("focusout", function (e) {
                if (!$container[0].contains(e.relatedTarget) && !$container.is(":hover")) {
                    resume();
                }
            });

            if (userPaused) {
                stop();
            }
            $bar.append($btn);
            render();
        },

        seasonalBannerImageClick: function () {
            $('.genericContainer .seasonal__banner--list .seasonal__banner--item img').on('click', function(e){
                if(e.currentTarget.closest('a').hasAttribute('href')){
                    let text = e.currentTarget.getAttribute('alt');
                    let ele = $(e.currentTarget).closest('.swiper-slide-active')[0];
                    let bannerNumber = ele ? Number(ele.getAttribute("data-swiper-slide-index"))+1 : 1;
                    var obj = seasonalBanner.methods.dataLayerObj(text, text+"_Middle_Type1", bannerNumber, "Middle_Type1");
                    createDataLayer('bannerClick', obj);
                }
            });
            $('.dropdown-item.header__navbar--dropdown-column .seasonal__banner--item img').on('click', function(e){
                if(e.currentTarget.closest('a').hasAttribute('href')){
                    let text = e.currentTarget.getAttribute('alt');
                    var obj = seasonalBanner.methods.dataLayerObj(text, text+"_Top_Nav_Type1", 1, "Top_Nav_Type1");
                    createDataLayer('bannerClick', obj);
                }
            });
        },

        seasonalBannerButtonClick: function(){
            $(".genericContainer .seasonal__banner--list .seasonal__banner__wrapper a").on('click', function(e){
                if(e.currentTarget.closest('a').hasAttribute('href')){
                    let titleElement = e.currentTarget.parentElement.getElementsByClassName('heading-2')[0];
                    let title = titleElement.innerText.replace(/\n/g, '').trim();
                    let buttonName = e.currentTarget.innerText;
                    let ele = e.currentTarget.getElementsByClassName("swiper-slide-active")[0];
                    let bannerNumber = ele ? Number(ele.getAttribute("data-swiper-slide-index"))+1 : 1;
                    let obj = seasonalBanner.methods.dataLayerObj(buttonName, title+" Middle_Type2", bannerNumber, "Middle_Type2");
                    createDataLayer("buttonClick", obj);
                }
            });
            $(".dropdown-item.header__navbar--dropdown-column .seasonal__banner__wrapper a").on('click', function(e){
                if(e.currentTarget.closest('a').hasAttribute('href')){
                    let titleElement = e.currentTarget.parentElement.getElementsByClassName('heading-2')[0];
                    let title = titleElement.innerText.replace(/\n/g, '').trim();
                    let buttonName = e.currentTarget.innerText;
                    let ele = e.currentTarget.getElementsByClassName("swiper-slide-active")[0];
                    let bannerNumber = ele ? Number(ele.getAttribute("data-swiper-slide-index"))+1 : 1;
                    let obj = seasonalBanner.methods.dataLayerObj(buttonName, title+" TopNav_Type2", bannerNumber, "TopNav_Type2");
                    createDataLayer("buttonClick", obj);
                }
            });
        },

        dataLayerObj : function(e, el, bannerNumber, pageSection) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e ? e.replace(/\n/g, '').trim():"",
                'pageSection' : pageSection ? pageSection : "Banner",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : el+" Banner",
                'bannerType' : el+" Banner_"+bannerNumber
            };
            return obj;
        }
    },
};

if ($(".seasonal__banner").length) {
    seasonalBanner.methods.init();
}
$(document).ready(function () {
seasonalBanner.methods.seasonalBannerImageClick();
seasonalBanner.methods.seasonalBannerButtonClick();
});
